import React from 'react'
import OrdersPreparedContainer from '../../../../Components/OrdersPart/OrdersPreparedContainer/OrdersPreparedContainer'
import Layout from '../../Layout'

const OrdersPrepared = () => {
  return (
    <Layout>
        <OrdersPreparedContainer/>
    </Layout>
  )
}

export default OrdersPrepared